<template>
  <div>
    <div class="box">
      <BInputPullDown
        label-name="机构"
        :required="true"
        v-model="accountInfo.organizationId"
        :Options="organizationList"
        style="margin: 12px 0 12px 0;"
        placeholder="请选择机构"
      />
    </div>
    <div class="box">
      <BInputText
        label-text="账号"
        :required="true"
        v-model="accountInfo.account"
        :maxLength="20"
        placeholder="请输入账号"
      />
    </div>
    <div class="box">
      <BInputText
        label-text="密码"
        :required="true"
        v-model="accountInfo.password"
        :maxLength="20"
        type="password"
        placeholder="请输入密码"
      />
    </div>
    <div class="box">
      <BInputText
        label-text="确认密码"
        :required="true"
        v-model="accountInfo.rpassword"
        :maxLength="20"
        type="password"
        placeholder="请确认密码"
      />
    </div>
    <div class="box">
      <BInputText
        label-text="账号名称"
        :required="true"
        v-model="accountInfo.userName"
        :maxLength="20"
        placeholder="账号名称"
      />
    </div>
     <div class="search-result">
            <div class="search-functions-headers">
                <div class="search-functions">
                    <BBtnPrimary
                      v-if="userid == 0"
                      :clicked="doSave"
                      btn-txt="添加"/>
                    <BBtnPrimary
                      v-else
                      :clicked="doUpdate"
                      btn-txt="编辑"/>
                    <BBtnPrimary
                      :clicked="doBack"
                      btn-txt="返回"/>
                </div>
            </div>
        </div>
  </div>
</template>
<script>
import { add,detail,updata } from '@/api/administrarors'
import BInputText from "../../components2/BInputText";
import BInputPullDown from "../../components2/BInputPullDown";
import BBtnPrimary from "../../components2/BBtnPrimary";
import Vue from "vue";
  export default {
    components: {
      BInputText,
      BInputPullDown,
      BBtnPrimary,
    },
    props:{
      editflg: Boolean,
      id: Number,
    },
    data(){
      return {
        accountInfo: {
          id:0,
          account: '',
          password: '',
          userName:'',
          rpassword:'',
          organizationId:'',
        },
        userid:"",
        messageText: "",
        sexList: [],
        organizationList: [],
        editFlag:true,
        routerflg:'',
        navi: [
          {name: "administrarors-management"},
          {name: "administrarors-add"},
        ],
      };
    },
    beforeMount() {
      this.$store.commit('SET_NAVI_DATA', this.navi);
    },
    created() {
        if (sessionStorage.getItem("store")) {
            this.$store.replaceState(
                Object.assign(
                    {},
                    this.$store.state,
                    JSON.parse(sessionStorage.getItem("store"))
                )
            );
            sessionStorage.removeItem("store");
        }
        window.addEventListener("beforeunload", () => {
            sessionStorage.setItem("store", JSON.stringify(this.$store.state));
        });
    },
    // 页面载入之前
    beforeRouteEnter (to, from, next) {
      next(vm => {
        if (vm.$route.params.editflg) {
        vm.userid = vm.$route.params.id;
        vm.routerflg = true;
        }
        const params = {
            userid: vm.$route.params.id,
            routerflg: vm.routerflg,
        };
        vm.userid = params.userid;
        if (
            params.userid !== null &&
            params.userid !== "" &&
            params.userid !== undefined 
        ) {
            // 把不为空的参数存入缓存
            vm.$store.commit("SET_ADMIN_DETAIL_PARAMS", params);
        }
        // 参数赋值
        if (
            vm.$store.state.administrarors_userId !== undefined &&
            vm.$store.state.administrarors_userId !== null &&
            vm.$store.state.administrarors_userId !== "" 
        ) {
            vm.userid = vm.$store.state.administrarors_userId;
        }
        vm.init();
      })
    },
    methods: {
       // 初始化
      async init () {
        var param = {
          id:this.userid
        }
        const data = await detail(param)
        this.accountInfo.userName = data.data.userName
        this.accountInfo.password = data.data.password
        this.accountInfo.rpassword = data.data.password
        this.accountInfo.account = data.data.account
        this.accountInfo.organizationId = data.data.organizationId
        this.sexList = data.data.sexList
        this.organizationList = data.data.organizationList
      },
      // 返回
      doBack () {
        this.$router.push({
          name: "administrarors-management",
        });
      },
      //添加
      async doSave () {
        this.doItemCheck()
        if (this.messageText !== '') {
          Vue.prototype.$valertbar.show(this.messageText);
          return
        }
        const data = await add(this.accountInfo)
        if (data.code === 0) {
          Vue.prototype.$vsnackbar.show(data.msg);
          this.doBack()
        } else {
          Vue.prototype.$valertbar.show(data.msg);
        }
      },
      //更新
      async doUpdate () {
        this.doItemCheck()
        if (this.messageText !== '') {
          Vue.prototype.$valertbar.show(this.messageText);
          return
        }
        this.accountInfo.id=this.userid;
        const data = await updata(this.accountInfo)
        if (data.code === 0) {
          Vue.prototype.$vsnackbar.show(data.msg);
          this.doBack()
        } else {
          Vue.prototype.$valertbar.show(data.msg);
        }
      },
      checkAccount(account){
        var reg = /^[0-9a-zA-Z]+$/
        if(!reg.test(account)){
          //alert("你输入bai的字符不是du数字或者字母")
          return false
        }else{
          return true
        }
      },
      // 项目验证
      doItemCheck () {
        // 验证
        this.messageText = ''
        if(this.accountInfo.organizationId === null || this.accountInfo.organizationId === ''){
          this.messageText = '请选择机构！'
          return false
        }
        if (this.accountInfo.account === null || this.accountInfo.account === '') {
          this.messageText = '账号必须输入！'
          return false
        }
        if(!this.checkAccount(this.accountInfo.account)){
          this.messageText = '账号只能输入字母或数字！'
          return false
        }
        // 密码
        if (this.accountInfo.password === null || this.accountInfo.password === '') {
          this.messageText = '密码必须输入！'
          return false
        }
        if (this.accountInfo.password.length>20) {
          this.messageText = '输入的密码长度不能超过20位！'
          return false
        }
        if (this.accountInfo.rpassword === null || this.accountInfo.rpassword === '') {
          this.messageText = '密码必须输入！'
          return false
        }
        // 在输入密码
        if (this.accountInfo.rpassword.length>20) {
          this.messageText = '输入的密码长度不能超过20位！'
          return false
        }
        if (this.accountInfo.password !==  this.accountInfo.rpassword) {
          this.messageText = '密码不一致！'
          return false
        }
         // 姓名验证
        if (this.accountInfo.userName === null || this.accountInfo.userName === '') {
          this.messageText = '姓名必须输入！'
          return false
        }
        if (this.accountInfo.userName.length > 20) {
          this.messageText = '输入的姓名长度不能超过20位！'
          return 
        }
        
        this.accountInfo.userName = this.comUtils.trim(this.accountInfo.userName)
      },
    },
  }
</script>

<style scoped>
.main2 {
        position: relative;
        /*margin: 5px 30px 5px 30px;*/
        padding-top: 28px;
        display: flex;
        flex-wrap: wrap;
    }

    .search-result {
        display: block;
        position: relative;
        margin: 30px 25px 5px 25px;
    }

    .search-functions-headers {
        position: relative;
        display: flex;
        justify-content: space-between;
        top: 0;
    }

    .search-functions {
        position: relative;
        top: 0;
        display: flex;
    }

    .search-result-summary {
        display: flex;
        align-items: center;
    }

    .search-result-summary .summary {
        margin: 0 50px 0 0;
    }

    .search-result-table {
        border-spacing: 0px;
        padding-bottom: 50px;
        width: 100%;
        margin-top: 10px;
    }

    .table-header-row {
        height: 67px;
        background: #f6f6f6;
    }

    .table-header-row th {
        text-align: left;
        padding: 10px;
    }

    .table-result-row {
        height: 78px;
        font-weight: 500;
        color: #333333;
    }

    .table-result-row td {
        border-bottom: 1px solid #ebebeb;
        padding: 10px;
        text-align: left;
    }

    .btn-detail {
        margin: 0 20px 0 20px;
        color: #0171a3;
        cursor: pointer;
    }

    .btn-delete {
        color: #fd1f58;
        cursor: pointer;
    }

    .box {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .box-time-pick {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .box-time-title {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-left: 90px;
    }

    .box-left {
        border-top: 1px solid black;
        border-bottom: 1px solid black;
        border-right: 1px solid black;
    }

    .box-right {
        border-top: 1px solid black;
        border-bottom: 1px solid black;
    }

    .inner-box {
        display: flex;
        flex-direction: column;
        width: 100%;
        flex-wrap: wrap;
        position: relative;
        justify-content: flex-start;
    }

    .label-box {
        color: #333333;
        text-align: right;
        font-size: 14px;
        margin: 0 10px 0 10px;
    }

    .label-box-sign {
        text-align: right;
        color: #333333;
        font-size: 14px;
        margin: 0 10px 0 23px;
    }

    .subtitle {
        color: #999999;
        margin: 15px 10px 15px 20px;
    }
    .box-time{
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
    }
</style>
